/**
 * cuisineEmojiMap.js - Maps cuisine tags to emoji prefixes.
 * Case-insensitive. Unrecognized tags fall back to fork-and-knife.
 */

const CUISINE_MAP = {
  "mexican": "\uD83C\uDF2E",
  "halal": "\uD83E\uDD59",
  "vegan": "\uD83C\uDF31",
  "vegetarian": "\uD83E\uDD66",
  "fusion": "\uD83D\uDD25",
  "bbq": "\uD83C\uDF56",
  "seafood": "\uD83E\uDD9E",
  "pizza": "\uD83C\uDF55",
  "burgers": "\uD83C\uDF54",
  "asian": "\uD83C\uDF5C",
  "indian": "\uD83C\uDF5B",
  "mediterranean": "\uD83C\uDF7F",
  "desserts": "\uD83E\uDDC1",
  "coffee": "\u2615",
  "juice": "\uD83E\uDD64",
  "korean": "\uD83E\uDD62",
  "thai": "\uD83C\uDF36",
  "american": "\uD83E\uDD85",
  "caribbean": "\uD83C\uDF34",
  "ethiopian": "\uD83E\uDED3",
  "peruvian": "\uD83C\uDF3D",
  "filipino": "\uD83C\uDF5A",
  "vietnamese": "\uD83C\uDF43",
  "gluten free": "\uD83C\uDF3E",
  "gluten-free": "\uD83C\uDF3E",
  "chinese": "\uD83E\uDD61",
  "japanese": "\uD83C\uDF63",
  "breakfast": "\uD83E\uDD5E",
  "tacos": "\uD83C\uDF2E",
  "ice cream": "\uD83C\uDF66",
  "bakery": "\uD83E\uDD50",
  "sandwiches": "\uD83E\uDD6A",
  "wings": "\uD83C\uDF57",
  "sushi": "\uD83C\uDF63",
  "ramen": "\uD83C\uDF5C",
  "poke": "\uD83D\uDC1F",
  "soul food": "\uD83C\uDF56",
  "cajun": "\uD83E\uDD90",
  "hawaiian": "\uD83C\uDF3A",
  "greek": "\uD83E\uDED2"
};

const FALLBACK = "\uD83C\uDF74";

export function getCuisineEmoji(tag) {
  if (!tag) return FALLBACK;
  var key = tag.toLowerCase().trim();
  return CUISINE_MAP[key] || FALLBACK;
}

export default CUISINE_MAP;
